import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

class UserProfileForm extends React.Component {
  constructor(props, context) {
    super(props);

    this.renderField = this.renderField.bind(this);
  }

  static validate(values) {
    const errors = {};
    if (!values.email) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }

    if (!values.firstName) {
      errors.firstName = 'Required';
    }

    if (!values.lastName) {
      errors.lastName = 'Required';
    }

    if ((values.password || values.password2) && values.password !== values.password2) {
      errors.password2 = 'Passwords do not match';
    }

    return errors;
  }

  static warn(values) {
    const warnings = {};
    // if (values && values.email && values.email.indexOf('@readytouch.com') == -1) {
    //   warnings.email = 'Hmm, you are not using readytouch.com...'
    // }
    return warnings;
  }

  renderField({ input, label, type, disabled, meta: { touched, error, warning } }) {
    // console.log('renderField', arguments);
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <input
          {...input}
          className='pure-input-1-3'
          placeholder={label}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form
        className='user-form pure-form pure-form-aligned'
        style={{ padding: '20px 0' }}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <Field
            name='email'
            component={this.renderField}
            type='text'
            label='Email'
            disabled={true}
          />
          <Field name='firstName' component={this.renderField} type='text' label='First Name' />
          <Field name='lastName' component={this.renderField} type='text' label='Last Name' />
          <Field
            name='role'
            component={this.renderField}
            type='text'
            label='Role'
            disabled={true}
          />
          <Field name='password' component={this.renderField} type='password' label='Password' />
          <Field
            name='password2'
            component={this.renderField}
            type='password'
            label='Confirm Password'
          />
          <div className='pure-controls'>
            <button className='pure-button pure-button-primary' type='submit' disabled={submitting}>
              Update
            </button>
          </div>
        </fieldset>
      </form>
    );
  }
}

// Decorate the form component
UserProfileForm = reduxForm({
  form: 'userProfile', // a unique name for this form
  validate: UserProfileForm.validate,
  warn: UserProfileForm.warn,
})(UserProfileForm);

UserProfileForm = connect((state) => ({
  initialValues: state.auth.user,
}))(UserProfileForm);

export default UserProfileForm;



// WEBPACK FOOTER //
// ./src/components/UserProfileForm.js